import React from 'react';
import './SuccessPopup.css';
import successImage from  '../assets/images/success.png';


function  SuccessPopup({onClose, message}) {


  return (
    <>
      <div className='overlay-success'>

        <div className="main-frame-success">

          <div className="text-content-title">
           <img src={successImage} alt='Error' style={{ width: "70px", height: "70px" }}/>
            <p  style={{ color:"green", fontSize:"30px", marginTop:"20px", fontWeight:"500" }}>
              {message}
            </p>
          </div>
          <div className='finish-button-success' >
              <p className="div" onClick={onClose} style={{ backgroundColor:"green"}} >Close</p>
              {/* <p className="div" onClick={onClose}>Finished</p> */}
           
          </div>

        </div>

      </div>
    </>
  );
}

export default SuccessPopup;